import { createStore, createHook, type StoreActionApi } from 'react-sweet-state';

type State = {
	shouldRefetchEpicPanel: boolean;
};

type StoreApi = StoreActionApi<State>;

const triggerEpicPanelRefetch =
	() =>
	({ setState }: StoreApi) => {
		setState({
			shouldRefetchEpicPanel: true,
		});
	};

const finishEpicPanelRefetch =
	() =>
	({ setState }: StoreApi) => {
		setState({
			shouldRefetchEpicPanel: false,
		});
	};

const actions = {
	triggerEpicPanelRefetch,
	finishEpicPanelRefetch,
} as const;

type Actions = typeof actions;

// this is a global store for checking if we should refetch epic
export const EpicPanelRefetchStore = createStore<State, Actions>({
	name: 'jira-software-backlog-panel-should-refetch-epic',
	initialState: {
		shouldRefetchEpicPanel: false,
	},
	actions,
});

export const useShouldRefetchEpicPanel = createHook(EpicPanelRefetchStore);
